(function ($) {

  // Mobile Menu
  const $body = $('body');
  $('.js-mobile-trigger').on('click', function (e) {
    e.preventDefault();
    $body.addClass('mobile-menu-appearing');
    setTimeout(function () {
      $body.addClass('mobile-menu-appeared');
      setTimeout(function () {
        $body.addClass('mobile-menu-appeared-still');
      }, 400);
    }, 100);
  });

  // Close menu when menu item clicked
  $('.mobile-menu a:not([href^="#"])').on('click', function (e) {
    e.preventDefault();

    $('body').addClass('mobile-menu-closing');
    setTimeout(function () {
      $('body').removeClass('mobile-menu-closing mobile-menu-appeared mobile-menu-appearing');
      window.location.href = e.currentTarget.href;
    }, 250);
  });

  // Mobile Menu Close
  $('.js-mobile-menu-close').on('click', function (e) {
    e.preventDefault();

    $body.addClass('mobile-menu-will-close');
    setTimeout(function () {
      $body.addClass('mobile-menu-closing');
      setTimeout(function () {
        $('body').removeClass('mobile-menu-will-close mobile-menu-closing mobile-menu-appeared mobile-menu-appearing mobile-menu-appeared-still');
      }, 250);
    }, 200);
  });

  // Prevent default the menu item without link
  $('.mobile-menu a[href^="#"]').on('click', function (e) {
    e.preventDefault();
  });


})(jQuery);